import { SmartComponent } from "smart-component-js";

class Estimator extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    init() {
        const tabs = this.element.querySelectorAll(".tab-button");
        const contents = this.element.querySelectorAll(".tab-content");

        tabs.forEach(tab => {
            tab.addEventListener("click", () => {
                tabs.forEach(t => t.classList.remove("active"));
                contents.forEach(c => c.classList.remove("active"));

                tab.classList.add("active");
                const targetContent = this.element.querySelector(`#${tab.dataset.tab}`);
                if (targetContent) {
                    targetContent.classList.add("active");
                }
            });
        });

        const inputs = this.element.querySelectorAll(".tab-content input, .tab-content select");
        inputs.forEach(input => {
            const updateBorderColor = () => {
                if (input.type === "date") {
                    if (!input.value) {
                        input.style.borderColor = "transparent";
                    } else {
                        input.style.borderColor = "green";
                    }
                }
                else if (input.tagName === "SELECT") {
                    if (input.value === "default") {
                        input.style.borderColor = "transparent";
                    } else {
                        input.style.borderColor = "green";
                    }
                } else {
                    if (input.value.trim() === "") {
                        input.style.borderColor = "transparent";
                    } else {
                        input.style.borderColor = "green";
                    }
                }
                this.checkForm(); // Verifica ogni volta che viene modificato un campo
            };

            input.addEventListener("input", updateBorderColor); // Per text
            input.addEventListener("change", updateBorderColor); // Per date e select

            input.style.borderColor = "transparent";
        });

        const dateInputs = this.element.querySelectorAll('input[type="date"]');
        dateInputs.forEach(dateInput => {
            flatpickr(dateInput, {
                dateFormat: "d/m/Y",
            });
        });

        const calendarIcons = this.element.querySelectorAll(".calendar-icon");
        calendarIcons.forEach(icon => {
            const input = icon.previousElementSibling;
            icon.addEventListener("click", () => {
                flatpickr(input).open(); // Apre il calendario
            });
        });

        // Gestione della checkbox privacy
        const privacyCheckbox = this.element.querySelectorAll('.privacy-consent-checkbox');
        privacyCheckbox.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                this.checkForm(); // Verifica lo stato del form quando cambia la privacy
            });
        });

        // Verifica il form per abilitare o disabilitare il pulsante
        this.checkForm();
    }

    checkForm(tabId = 'tab1') {
        const currentTab = this.element.querySelector(`#${tabId}`);
        const inputs = currentTab.querySelectorAll('input[required], select');
        const isFormValid = [...inputs].every(input => {
            if (input.type === 'checkbox') return input.checked;
            return input.value.trim() !== '';
        });

        const privacyCheckbox = currentTab.querySelector('.privacy-consent-checkbox');
        const button = currentTab.querySelector('.primary-button');

        if (isFormValid && privacyCheckbox.checked) {
            button.classList.remove('disabled');
        } else {
            button.classList.add('disabled');
        }
    }
}

export default Estimator;
